var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{key:_vm.val,class:{ loading: !_vm.loaded },attrs:{"cdn-img":"","src":_vm.val,"alt":_vm.description},on:{"load":_vm.onImageLoad}})}
var staticRenderFns = []

export { render, staticRenderFns }